module.exports = true;



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/_library.js
// module id = 89
// module chunks = 13